import {FetchBaseQueryError} from '@reduxjs/toolkit/dist/query'

import {AuthErrorMessage} from 'airship/clients/auth/types'
import {KeyValue} from 'airship/modules/typesafe-request'

import {DEFAULT_LOGIN_ERROR_MESSAGE} from './constants'

export const redirect = (urlOrPath: string): void => {
  window.location.assign(urlOrPath)
}

export const getQueryStringParams = (): KeyValue => {
  const params = new URLSearchParams(window.location.search)
  return Object.fromEntries(params.entries())
}

export const getLoginErrorMessage = (error: FetchBaseQueryError): string => {
  if (error.status === 401 && error.data === AuthErrorMessage.VALIDATION) {
    return 'Username and/or password is invalid.'
  } else if (error.status === 401) {
    return 'Login failed.'
  }
  return DEFAULT_LOGIN_ERROR_MESSAGE
}
